<app-header></app-header>
<div class="container-fluid " [style.font-family]="'var(--vex-font)'" style="background: linear-gradient(180deg, #2d7cfd 0%, #2d7cfd 39.94%, #4fa5f4 113.79%)">
  <div style="background: linear-gradient(180deg, rgba(0, 0, 0, 0.58) 0%, rgba(0, 0, 0, 0) 100%)">
    <div class="container py-24">
      <p class="text-center text-5xl font-bold text-white">ORBIT</p>
      <p class="pt-8 text-4xl text-center font-bold text-white">Our journey unfolds.</p>
      <p class="text-2xl text-center text-white pt-4">Streamline, Simplify, and Succeed Together</p>
    </div>
  </div>
</div>

<!--
<div class="container mx-auto p-4 mt-10 md:mt-20">
  <div class="bg-white shadow-md rounded-2xl overflow-hidden">
    <div class="relative" style="padding-top: 40%;">
      <iframe class="absolute inset-0 w-full h-full" src="https://www.youtube.com/embed/ffqhigwoass?si=gMd-wElk7zRBMBb2"
              title="YouTube video player" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>
  </div>
</div>
-->

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:w-1/2 p-4 flex justify-center items-center rounded-2xl">
        <img src="/assets/images/about-us/about1.png" alt="Image" class="max-w-full">
      </div>
      <div class="w-full md:w-1/2 p-4">
        <p class="text-2xl md:text-4xl mb-2 font-semibold">Our Company Overview</p>
        <p class="text-lg md:text-xl text-justify text-zinc-500">
          At Volmint Technologies, we stand at the forefront of innovation in enterprise solutions with a singular focus: empowering organizations to streamline and elevate their office and business operations effortlessly. Our flagship product, “ORBIT – Office ERP,” represents the pinnacle of our dedication to efficiency, automation, and user-centric design. Founded on a commitment to excellence, Volmint has consistently delivered cutting-edge software ecosystems tailored to meet the dynamic needs of modern businesses worldwide. Our team of visionary developers and industry experts collaborates tirelessly to ensure that “ORBIT – Office ERP” not only meets but exceeds client expectations in managing operations with precision and ease.
        </p>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:w-1/2 p-4">
        <p class="text-2xl md:text-4xl mb-2 font-semibold">Charting the Future: Our Vision and Mission</p>
        <p class="text-lg md:text-xl text-justify text-zinc-500">Pioneering the future of office and business management by delivering intuitive ERP solutions that empower organizations worldwide. Our mission is to revolutionize operational processes with cutting-edge technology, ensuring businesses experience a streamlined, efficient, and seamless journey from planning to execution.</p>
        <div class="w-full flex justify-center md:justify-start">
        <button
          class="mt-12 flex items-center px-6 py-3 text-xl border border-indigo-900 text-indigo-900 hover:bg-indigo-900 hover:text-white transition rounded-lg whitespace-nowrap duration-200"
          (click)="goTo('auth/register')">
          Experience it Now
        </button>
        </div>
      </div>
      <div class="w-full md:w-1/2 p-4 flex justify-center items-center rounded-2xl">
        <img src="/assets/images/about-us/about2.png" alt="Image" class="max-w-full">
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:w-1/2 p-4 flex justify-center items-center rounded-2xl">
        <img src="/assets/images/about-us/about3.png" alt="Image" class="max-w-full">
      </div>
      <div class="w-full md:w-1/2 p-4">
        <p class="text-2xl md:text-4xl mb-2 font-semibold">Why Do You Need ORBIT – Office ERP?</p>
        <p class="text-lg md:text-xl text-zinc-500 text-justify mb-16">
          ORBIT’s ERP is essential for smooth organizational operations, offering powerful features and benefits that streamline workflows and enhance efficiency. It enables businesses to centralize processes seamlessly, monitor and optimize performance, and empower stronger connections across teams and departments.
        </p>
        <div class="w-full flex justify-center md:justify-start">
        <button
          class="mt-12 flex items-center px-6 py-3 text-xl border border-indigo-900 text-indigo-900 hover:bg-indigo-900 hover:text-white transition rounded-lg whitespace-nowrap duration-200"
          (click)="goTo('auth/register')">
          Sign up now
        </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20 bg-about4 rounded-none" [style.font-family]="'var(--vex-font)'">
  <div class="container py-12 rounded-none">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:mt-24 pt-4 md:pt-12 p-4 md:w-1/2">
        <p class="text-2xl md:text-4xl mb-2 font-semibold text-center md:text-start">Multi-Department Mastery: </p>
        <p class="text-2xl md:text-4xl mb-2 font-semibold text-center md:text-start">Simplify Operations Across </p>
        <p class="text-2xl md:text-4xl mb-2 font-semibold text-center md:text-start">Teams</p>
      </div>
      <div class="w-full md:w-1/2 p-4 flex justify-center items-center rounded-2xl">
        <img src="/assets/images/about-us/add_multiple_companies.webp" alt="Image" class="max-w-full">
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:w-1/2 p-4">
        <p class="text-2xl md:text-4xl mb-2 font-semibold">Lead the Way: Smarter Office Management</p>
        <p class="text-lg md:text-xl text-zinc-500 text-justify">ORBIT – Office ERP empowers organizations with a comprehensive suite of tools that streamline daily operations, optimize workflows, and ensure seamless coordination across departments for maximum efficiency and growth.</p>
      </div>
      <div class="w-full md:w-1/2 p-4 flex justify-center items-center rounded-2xl">
        <img src="/assets/images/about-us/about5.png" alt="Image" class="max-w-full">
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:w-1/2 flex justify-center items-center rounded-2xl">
        <img src="/assets/images/about-us/about6.png" alt="Image" class="max-w-full">
      </div>
      <div class="w-full md:w-1/2 p-4">
        <p class="text-2xl md:text-4xl mb-2 font-semibold">Clear Paths, Bright Futures: Streamlining Office Operations</p>
        <p class="text-lg md:text-xl text-justify text-zinc-500">ORBIT Office ERP ensures smooth internal communication and timely notifications, keeping teams informed and connected across departments. It enhances workflow clarity and operational efficiency, enabling organizations to function seamlessly.</p>
        <div class="w-full flex justify-center md:justify-start">
        <button
          class="mt-12 flex items-center px-6 py-3 text-xl border border-indigo-900 text-indigo-900 hover:bg-indigo-900 hover:text-white transition rounded-lg whitespace-nowrap duration-200"
          (click)="goTo('auth/register')">
          ORBIT Today
        </button>
      </div>
      </div>
    </div>
  </div>
</div>

<!--
<div class="container-fluid mt-10 md:mt-20 bg-consultancy py-12" [style.font-family]="'var(&#45;&#45;vex-font)'" >
  <div class="container">
    <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2  ">
      <div class="">
        <div class="w-full flex justify-center md:justify-start">
        <img src="assets/images/Chat.png" alt="Image" class="py-5"/>
        </div>
        <h1 class="font-inter text-white text-3xl font-medium text-center md:text-start">Get a free consultation from our expert</h1>
        <h1 class="font-inter text-white text-5xl font-bold text-center md:text-start"> Right Now!</h1>
        <p class="text-white text-xl pt-3 pb-20 text-center md:text-start">Discover what's possible with Volmint Technologies. Let's Innovate, Grow, and Succeed together.</p>
      </div>
      <div class="md:relative lg:relative flex justify-end">
        <div class="bg-white px-8 mt-2 md:mt-20 rounded-lg w-full max-w-lg md:absolute lg:absolute">
          <form class="p-6 flex flex-col gap-4" [formGroup]="addEnquiryForm" (ngSubmit)="submit()">
            <p class="text-center text-2xl font-semibold text-maroon mb-4">Request For a Free Consultation & see the difference!</p>
            <div class="flex flex-col gap-4">
              <div class="relative pb-2">
                <label for="name" class="block text-lg font-medium text-gray-700 mb-1">Name</label>
                <input id="name" formControlName="name" type="text" placeholder="John Doe"
                       class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                       required>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('name').hasError('required')">
                  Name field is required
                </small>
              </div>
              <div class="relative pb-2">
                <label for="email" class="block text-lg font-medium text-gray-700 mb-1">Email</label>
                <input id="email" formControlName="email" type="email" placeholder="abctestmail@gmail.com"
                       class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                       required>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('email').hasError('required')">
                  Email field is required
                </small>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('email').hasError('pattern')">
                  Invalid email format
                </small>
              </div>
              <div class="relative pb-2">
                <label for="contact" class="block text-lg font-medium text-gray-700 mb-1">Phone Number</label>
                <input id="contact" formControlName="contact" type="tel" placeholder="+91-7836899999"
                       class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                       required>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('contact').hasError('required')">
                  Contact field is required
                </small>
              </div>
              <div class="relative pb-2">
                <label for="subject" class="block text-lg font-medium text-gray-700 mb-1">Subject</label>
                <input id="subject" formControlName="subject" type="text" placeholder="Subject"
                       class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                       required>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('subject').hasError('required')">
                  Subject field is required
                </small>
              </div>
              <button type="submit"
                      class="table-header-color text-white py-3 mt-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out">
                Get a Call Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
-->

<div class="container-fluid mt-10 md:mt-72 bg-faq py-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <p class="text-center text-2xl md:text-4xl font-semibold">
      Frequently Asked Questions
    </p>
    <div class="flex flex-col md:flex-row justify-between items-center gap-8 pt-8">
      <div class="flex-1 flex-shrink-0">
        <img src="/assets/images/features-images/frequently-asked-questions.webp" alt="FAQ Image" class="w-full md:h-96 rounded-2xl"/>
      </div>
      <div class="flex-1 flex flex-col">
        <div class="flex-1 flex flex-col md:max-w-xl px-1 md:px-0">
          <mat-accordion class="p-2 flex-1">
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header class="flex items-center">
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                    What is ORBIT Office ERP?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 md:pt-0 md:mt-0 text-justify text-zinc-500">
                ORBIT is an office management system developed and owned by Volmint Technologies. This ERP is designed to
                streamline office operations and manage them with the ease of technology, ensuring better communication,
                interdepartmental collaboration, and workflow efficiency.</p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                      Is ORBIT secure for data management?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                Absolutely, ORBIT is built with robust data security in mind. From encryption to role-based access restrictions,
                the system ensures that sensitive company information is properly safeguarded, providing you with confidence and
                peace of mind when managing key processes.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                    What are the features of ORBIT?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                ORBIT Office ERP brings all your operations under one roof. From managing and tracking employee data to
                organizational performance, the system offers document management, live reports & analytics, payroll management,
                access control, multi-department management, device management, holiday & leave tracking, and robust
                communication management to run an organization smoothly.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                      Why does ORBIT Office ERP matter for businesses?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                ORBIT automates repetitive tasks so employees can focus on crucial work and be more productive. It offers a
                centralized system to boost collaboration, sends smart notifications & alerts, ensures multi-layer security, and
                provides live reports & analytics for data-driven decision-making.
              </p>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="above-footer py-12" [style.font-family]="'var(&#45;&#45;vex-font)'">
  <div class="container">
    <div class="m-auto text-center">
      <img src="./assets/images/img-group.png" alt="" class="mx-auto">
      <h3 class="mt-5 text-white text-xl font-medium">
        Need any further assistance?
      </h3>
      <p class="mt-4 text-white ">
        Feel free to reach out for any inquiries or assistance.
      </p>
      <button type="button" class="mt-5 px-3 py-2 bg-white text-[#6752A9] rounded" (click)="goTo('/contact-us')">
        Book an appointment now!
      </button>
    </div>
  </div>
</div>
<app-footer></app-footer>



